var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopySizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.94 5.87999L17.11 3.04999C16.59 2.52999 15.9 2.23999 15.17 2.23999H11C9.48 2.23999 8.25 3.46999 8.25 4.98999V15C8.25 16.52 9.48 17.75 11 17.75H15.25V19C15.25 19.69 14.69 20.25 14 20.25H7C6.31 20.25 5.75 19.69 5.75 19V6.99999C5.75 6.58999 5.41 6.24999 5 6.24999C4.59 6.24999 4.25 6.58999 4.25 6.99999V19C4.25 20.52 5.48 21.75 7 21.75H14C15.52 21.75 16.75 20.52 16.75 19V17.75H18C19.52 17.75 20.75 16.52 20.75 15V7.82999C20.75 7.09999 20.46 6.40999 19.94 5.88999V5.87999ZM18.88 6.93999C18.97 7.02999 19.03 7.13999 19.08 7.24999H15.99C15.85 7.24999 15.74 7.13999 15.74 6.99999V3.90999C15.85 3.96999 15.96 4.02999 16.05 4.10999L18.88 6.93999ZM18 16.25H11C10.31 16.25 9.75 15.69 9.75 15V4.99999C9.75 4.30999 10.31 3.74999 11 3.74999H14.25V6.99999C14.25 7.95999 15.04 8.74999 16 8.74999H19.25V15C19.25 15.69 18.69 16.25 18 16.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySizer);
export default __webpack_public_path__ + "static/media/copySizer.9b6dfeaf.svg";
export { ForwardRef as ReactComponent };